import { Features } from "../enums/features.enum";
import { PaginationMode } from "../enums/pagination-mode.enum";
import { PaginationConfig } from "../models/pagination-config";

export const PaginationConfigByFeature: Record<Features, PaginationConfig> = {
    [Features.SessionManagementView]: {
        mode: PaginationMode.Server,
        enabled: true,
        startPage: 1,
        defaultPageSize: 25,
        availablePageSizes: [25, 50, 100]
    },
    [Features.DocumentLibraryView]: {
        mode: PaginationMode.Server,
        enabled: true,
        startPage: 1,
        defaultPageSize: 25,
        availablePageSizes: [25, 50, 100]
    },
      [Features.ChangeRegisterView]: {
        mode: PaginationMode.Server,
        enabled: true,
        startPage: 1,
        defaultPageSize: 25,
        availablePageSizes: [25, 50, 100]
    },
    [Features.CourseCatalogueView]: {
        mode: PaginationMode.Server,
        enabled: true,
        startPage: 1,
        defaultPageSize: 25,
        availablePageSizes: [25, 50, 100]
    },
    [Features.TrainingPlanView]: {
        mode: PaginationMode.Server,
        enabled: true,
        startPage: 1,
        defaultPageSize: 25,
        availablePageSizes: [25, 50, 100]
    },
    [Features.TrainingStatusReportView]: {
        mode: PaginationMode.Server,
        enabled: true,
        startPage: 1,
        defaultPageSize: 25,
        availablePageSizes: [25, 50, 100]
    },
    [Features.SkillsSearchView]: {
        mode: PaginationMode.Server,
        enabled: true,
        startPage: 1,
        defaultPageSize: 25,
        availablePageSizes: [25, 50, 100]
    },
    [Features.SkillTrainingItems]: {
        mode: PaginationMode.Client,
        enabled: true,
        startPage: 1,
        defaultPageSize: 25,
        availablePageSizes: [25, 50, 100]
    }
};
